import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ScrollToTop } from '../../../components/common/scroll-to-top/scroll-to-top';

import { BlockedUsers } from '../../blocked-users/blocked-users';

/**
 * Dashboard page for "Blocked Users" (/dashboard/blocked-user), reachable
 * from its own entry in the main sidebar (app-sidebar).
 *
 * This is just a thin page wrapper — all of the actual listing/unblock
 * logic already lives in <app-blocked-users> (previously only used as a
 * tab on the profile page), so it's reused here as-is rather than
 * duplicated.
 */
@Component({
  selector: 'app-blocked-user',
  standalone: true,
  imports: [CommonModule, ScrollToTop, BlockedUsers],
  templateUrl: './blocked-user.html',
})
export class BlockedUser {}
